import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
const Alert = ({ variant = 'info', dismissible = false, onClose, children, className = '', show = true }) => {
    const [isVisible, setIsVisible] = useState(show);
    const handleClose = () => {
        setIsVisible(false);
        if (onClose) {
            onClose();
        }
    };
    if (!isVisible) {
        return null;
    }
    const getVariantStyles = () => {
        switch (variant) {
            case 'primary':
                return { backgroundColor: '#cce5ff', color: '#004085', borderColor: '#b8daff' };
            case 'secondary':
                return { backgroundColor: '#e2e3e5', color: '#383d41', borderColor: '#d6d8db' };
            case 'success':
                return { backgroundColor: '#d4edda', color: '#155724', borderColor: '#c3e6cb' };
            case 'danger':
                return { backgroundColor: '#f8d7da', color: '#721c24', borderColor: '#f5c6cb' };
            case 'warning':
                return { backgroundColor: '#fff3cd', color: '#856404', borderColor: '#ffeaa7' };
            case 'info':
                return { backgroundColor: '#d1ecf1', color: '#0c5460', borderColor: '#bee5eb' };
            case 'light':
                return { backgroundColor: '#fefefe', color: '#818182', borderColor: '#fdfdfe' };
            case 'dark':
                return { backgroundColor: '#d6d8db', color: '#1b1e21', borderColor: '#c6c8ca' };
            default:
                return { backgroundColor: '#d1ecf1', color: '#0c5460', borderColor: '#bee5eb' };
        }
    };
    const alertClasses = [
        'alert',
        `alert-${variant}`,
        dismissible ? 'alert-dismissible' : '',
        className
    ].filter(Boolean).join(' ');
    return (_jsxs("div", { className: alertClasses, style: {
            padding: '0.75rem 1.25rem',
            marginBottom: '1rem',
            border: '1px solid transparent',
            borderRadius: '0.25rem',
            position: 'relative',
            ...getVariantStyles()
        }, children: [children, dismissible && (_jsx("button", { type: "button", className: "btn-close", onClick: handleClose, style: {
                    position: 'absolute',
                    top: '0',
                    right: '0',
                    padding: '0.75rem 1.25rem',
                    background: 'transparent',
                    border: '0',
                    fontSize: '1.5rem',
                    fontWeight: '700',
                    lineHeight: '1',
                    color: '#000',
                    textShadow: '0 1px 0 #fff',
                    opacity: '.5',
                    cursor: 'pointer'
                }, children: "\u00D7" }))] }));
};
export default Alert;
